import {Component, Input} from '@angular/core';
import {BankSlipValidateResponse} from '@gatewee/types/withdrawal';
import {WithdrawalAmountBreakdown} from '@gatewee/utils';

@Component({
  selector: 'app-bank-slip-step-review',
  templateUrl: './bank-slip-step-review.component.html',
  standalone: false,
})
export class BankSlipStepReviewComponent {
  @Input() validated: BankSlipValidateResponse | null = null;
  @Input() amountBreakdown: WithdrawalAmountBreakdown | null = null;
  @Input() description = '';
  @Input() insufficientBalance = false;
}
